// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-BookingDetails-Transactions-styles___tableHeadCell--clCqm {
  color: #1b2432 !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  height: 60px;
}

.components-BookingDetails-Transactions-styles___tableHead--j59nl {
  box-shadow: 0 2px 4px 0 rgba(109, 113, 122, 0.15);
}

.components-BookingDetails-Transactions-styles___tableHead--j59nl th:first-child {
    padding-left: 32px;
  }

.components-BookingDetails-Transactions-styles___tableHead--j59nl th:last-child {
    padding-right: 32px;
  }

.components-BookingDetails-Transactions-styles___tableRowCell--ZFvaa {
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 20px 24px !important;
  font-size: 15px !important;
  vertical-align: top !important;
}

.components-BookingDetails-Transactions-styles___tableRowCell--ZFvaa .components-BookingDetails-Transactions-styles___amountContainer--gNxiy {
    display: flex;
    align-items: center;
  }

.components-BookingDetails-Transactions-styles___tableRowCell--ZFvaa .components-BookingDetails-Transactions-styles___amountContainer--gNxiy svg {
      border: 1px solid #dddee0;
      border-radius: 50%;
      margin-right: 5px !important;
    }

.components-BookingDetails-Transactions-styles___description--HAgxy {
  text-wrap: auto;
}

.components-BookingDetails-Transactions-styles___tableRow--NDiAT:last-child .components-BookingDetails-Transactions-styles___tableRowCell--ZFvaa {
      border: none !important;
    }

.components-BookingDetails-Transactions-styles___tableRow--NDiAT:hover {
    background: #f6f6f7;
  }

.components-BookingDetails-Transactions-styles___status--hQo0y {
  border: 1px solid #12da9f;
  border-radius: 4px;
  font-size: 13px;
  color: #1b2432;
  font-weight: 600;
  padding: 6px 10px;
  display: inline-block;
}

.components-BookingDetails-Transactions-styles___completed--M4eHI {
  border: 1px solid #12da9f;
  background: rgba(18, 218, 159, 0.1);
}

.components-BookingDetails-Transactions-styles___pending--zqOWr {
  border: 1px solid #f79e3d;
  background: rgba(247, 158, 61, 0.1);
}

.components-BookingDetails-Transactions-styles___canceled--xhqz9 {
  background: rgba(242, 106, 89, 0.1);
  border: 1px solid #f26a59;
}

.components-BookingDetails-Transactions-styles___confirmationBodyTextStyle--mSuci {
  width: 450px;
}

.components-BookingDetails-Transactions-styles___refundButton--xy4ki {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px !important;
  height: 32px !important;
  border: 1px solid #318afb !important;
  border-radius: 4px !important;
  font-size: 13px !important;
  color: #318afb !important;
  letter-spacing: 0;
  text-align: center;
  z-index: 1;
}

.components-BookingDetails-Transactions-styles___tableRow--NDiAT td:first-child {
  position: relative;
  padding-left: 32px !important;
  border-bottom: none !important;
}

.components-BookingDetails-Transactions-styles___tableRow--NDiAT td:first-child:after {
  content: '';
  display: block;
  position: absolute;
  border-bottom: 1px solid rgba(224, 224, 224, 1) !important;
  left: 30px;
  right: 0px;
  bottom: -1px;
}

.components-BookingDetails-Transactions-styles___tableRow--NDiAT td:last-child {
  position: relative;
  padding-right: 32px !important;
  border-bottom: none !important;
  text-align: end;
}

.components-BookingDetails-Transactions-styles___tableRow--NDiAT td:last-child:after {
  content: '';
  display: block;
  position: absolute;
  border-bottom: 1px solid rgba(224, 224, 224, 1) !important;
  top: 10px;
  left: 0;
  right: 30px;
  bottom: -1px;
}

.components-BookingDetails-Transactions-styles___tableRowCellWithIcon--JdLwa {
  display: flex !important;
}

.components-BookingDetails-Transactions-styles___tableRowCellWithIcon--JdLwa svg {
    margin-right: 5px;
  }
`, "",{"version":3,"sources":["webpack://./components/BookingDetails/Transactions/styles.pcss"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,iDAAiD;AAOnD;;AANE;IACE,kBAAkB;EACpB;;AACA;IACE,mBAAmB;EACrB;;AAGF;EACE,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,8BAA8B;AAWhC;;AATE;IACE,aAAa;IACb,mBAAmB;EAMrB;;AALE;MACE,yBAAyB;MACzB,kBAAkB;MAClB,4BAA4B;IAC9B;;AAIJ;EACE,eAAe;AACjB;;AAII;MACE,uBAAuB;IACzB;;AAGF;IACE,mBAAmB;EACrB;;AAGF;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,0DAA0D;EAC1D,UAAU;EACV,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,0DAA0D;EAC1D,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;AAK1B;;AAHE;IACE,iBAAiB;EACnB","sourcesContent":[".tableHeadCell {\n  color: #1b2432 !important;\n  font-weight: 600 !important;\n  font-size: 13px !important;\n  height: 60px;\n}\n\n.tableHead {\n  box-shadow: 0 2px 4px 0 rgba(109, 113, 122, 0.15);\n  th:first-child {\n    padding-left: 32px;\n  }\n  th:last-child {\n    padding-right: 32px;\n  }\n}\n\n.tableRowCell {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  padding: 20px 24px !important;\n  font-size: 15px !important;\n  vertical-align: top !important;\n\n  .amountContainer {\n    display: flex;\n    align-items: center;\n    svg {\n      border: 1px solid #dddee0;\n      border-radius: 50%;\n      margin-right: 5px !important;\n    }\n  }\n}\n\n.description {\n  text-wrap: auto;\n}\n\n.tableRow {\n  &:last-child {\n    .tableRowCell {\n      border: none !important;\n    }\n  }\n\n  &:hover {\n    background: #f6f6f7;\n  }\n}\n\n.status {\n  border: 1px solid #12da9f;\n  border-radius: 4px;\n  font-size: 13px;\n  color: #1b2432;\n  font-weight: 600;\n  padding: 6px 10px;\n  display: inline-block;\n}\n\n.completed {\n  border: 1px solid #12da9f;\n  background: rgba(18, 218, 159, 0.1);\n}\n\n.pending {\n  border: 1px solid #f79e3d;\n  background: rgba(247, 158, 61, 0.1);\n}\n\n.canceled {\n  background: rgba(242, 106, 89, 0.1);\n  border: 1px solid #f26a59;\n}\n\n.confirmationBodyTextStyle {\n  width: 450px;\n}\n\n.refundButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 72px !important;\n  height: 32px !important;\n  border: 1px solid #318afb !important;\n  border-radius: 4px !important;\n  font-size: 13px !important;\n  color: #318afb !important;\n  letter-spacing: 0;\n  text-align: center;\n  z-index: 1;\n}\n\n.tableRow td:first-child {\n  position: relative;\n  padding-left: 32px !important;\n  border-bottom: none !important;\n}\n\n.tableRow td:first-child:after {\n  content: '';\n  display: block;\n  position: absolute;\n  border-bottom: 1px solid rgba(224, 224, 224, 1) !important;\n  left: 30px;\n  right: 0px;\n  bottom: -1px;\n}\n\n.tableRow td:last-child {\n  position: relative;\n  padding-right: 32px !important;\n  border-bottom: none !important;\n  text-align: end;\n}\n\n.tableRow td:last-child:after {\n  content: '';\n  display: block;\n  position: absolute;\n  border-bottom: 1px solid rgba(224, 224, 224, 1) !important;\n  top: 10px;\n  left: 0;\n  right: 30px;\n  bottom: -1px;\n}\n\n.tableRowCellWithIcon {\n  display: flex !important;\n\n  svg {\n    margin-right: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableHeadCell": `components-BookingDetails-Transactions-styles___tableHeadCell--clCqm`,
	"tableHead": `components-BookingDetails-Transactions-styles___tableHead--j59nl`,
	"tableRowCell": `components-BookingDetails-Transactions-styles___tableRowCell--ZFvaa`,
	"amountContainer": `components-BookingDetails-Transactions-styles___amountContainer--gNxiy`,
	"description": `components-BookingDetails-Transactions-styles___description--HAgxy`,
	"tableRow": `components-BookingDetails-Transactions-styles___tableRow--NDiAT`,
	"status": `components-BookingDetails-Transactions-styles___status--hQo0y`,
	"completed": `components-BookingDetails-Transactions-styles___completed--M4eHI`,
	"pending": `components-BookingDetails-Transactions-styles___pending--zqOWr`,
	"canceled": `components-BookingDetails-Transactions-styles___canceled--xhqz9`,
	"confirmationBodyTextStyle": `components-BookingDetails-Transactions-styles___confirmationBodyTextStyle--mSuci`,
	"refundButton": `components-BookingDetails-Transactions-styles___refundButton--xy4ki`,
	"tableRowCellWithIcon": `components-BookingDetails-Transactions-styles___tableRowCellWithIcon--JdLwa`
};
module.exports = ___CSS_LOADER_EXPORT___;
